import styled from 'styled-components';

const Logo = styled.img.attrs(({ theme }) => ({
  src: theme.images.logo
}))`
  width: 85px;

  @media (max-width: 1350px) {
    width: 4.6875rem;
  }
`;

export { Logo };
